import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, inject, NgModule, NO_ERRORS_SCHEMA, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
//import '@dsy/enel';
//import '@dsy/enelx';
import { AppComponent } from './app.component';
import { routes } from './app.routes';
import { WidgetLayoutComponent } from './components/widget-layout/widget-layout.component';
import { DatePipe } from '@angular/common';
import { ENVIRONMENT } from './app-config';
import { environment } from '@/environments/environment';
import { NgxGlobalContactFooterModule } from 'ngx-global-contact-footer';
import { NOC_ANALYTICS } from 'ngx-shared-services';
import { analytics } from 'noc-analytics';
import { provideTranslateService, TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TRANSLATE_HTTP_LOADER_CONFIG, TranslateHttpLoader } from '@ngx-translate/http-loader';

@NgModule({
	declarations: [
		AppComponent,
	],
	imports: [
		BrowserModule,
		RouterModule.forRoot(routes),
		WidgetLayoutComponent,
		NgxGlobalContactFooterModule.forRoot({ namespace: 'ngx-global-contact-footer.' }),
		TranslateModule
	],
	providers: [
		TranslateService,
		provideHttpClient(withInterceptorsFromDi()),
		DatePipe,
		provideTranslateService({
			loader: {
				provide: TranslateLoader,
				useClass: TranslateHttpLoader,
			},
		}),
		{ provide: NOC_ANALYTICS, useValue: analytics },
		{ provide: ENVIRONMENT, useValue: environment },
		{ provide: TRANSLATE_HTTP_LOADER_CONFIG, useValue: { prefix: '/assets/i18n/', suffix: '.json' } },
	],
	bootstrap: [AppComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AppModule { }
